import { Box, Container, Grid, Typography } from "@mui/material";

import sphereImage from "../../assets/sphere.webm";
import lendingImage from "../../assets/lending.svg";
import aiImage from "../../assets/ai.svg";
import chainImage from "../../assets/chain.svg";
import yieldImage from "../../assets/yield.svg";

const CoreStrength = ({ icon, title }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 2,
      p: 1.6,
      width: "100%",
    }}
  >
    <Box
      component="img"
      src={icon}
      alt={title}
      sx={{
        width: 48,
        height: 48,
      }}
    />
    <Typography
      sx={{
        fontSize: "18px",
        color: "#000",
        fontWeight: 500,
      }}
    >
      {title}
    </Typography>
  </Box>
);

const Hero = () => {
  const coreStrengths = [
    {
      icon: lendingImage,
      title: "Lending Markets & Staking Mechanisms",
    },
    {
      icon: aiImage,
      title: "AI-Driven Financial Solutions",
    },
    {
      icon: chainImage,
      title: "Cross-Chain Protocol Development",
    },
    {
      icon: yieldImage,
      title: "Yield Optimization Strategies",
    },
  ];

  return (
    <Box
      sx={{
        pt: { xs: 4, md: 8 },
        pb: { xs: 4, md: 8 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: "40px", md: "64px" },
                lineHeight: 1.2,
                mb: 3,
                background: "linear-gradient(90deg, #0D47FF 0%, #6B9AFF 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 400,
              }}
            >
              AI & Blockchain-Powered DeFi Innovation
            </Typography>

            <Typography
              sx={{
                fontSize: "18px",
                color: "#000",
                mb: 6,
                maxWidth: "580px",
              }}
            >
              Leading the Future of Decentralized Finance by integrating
              cutting-edge AI with blockchain technology. We specialize in
              building, deploying, and managing on-chain financial protocols.
            </Typography>

            <Typography
              variant="h5"
              sx={{
                fontSize: "24px",
                fontWeight: 600,
                mb: 3,
              }}
            >
              Our Core Strengths
            </Typography>

            <table style={{ borderCollapse: "collapse" }}>
              <tr>
                <td
                  style={{
                    border: "1px solid rgba(13, 71, 255, 0.04)",
                  }}
                >
                  <CoreStrength {...coreStrengths[0]} />
                </td>
                <td
                  style={{
                    border: "1px solid rgba(13, 71, 255, 0.04)",
                  }}
                >
                  <CoreStrength {...coreStrengths[1]} />
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid rgba(13, 71, 255, 0.04)",
                  }}
                >
                  <CoreStrength {...coreStrengths[2]} />
                </td>
                <td
                  style={{
                    border: "1px solid rgba(13, 71, 255, 0.04)",
                  }}
                >
                  <CoreStrength {...coreStrengths[3]} />
                </td>
              </tr>
            </table>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              component="video"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
              disablePictureInPicture
              disableRemotePlayback
              sx={{
                width: "100%",
                maxWidth: "600px",
                height: "auto",
                display: "block",
                margin: "0 auto",
                objectFit: "cover",
              }}
            >
              <source src={sphereImage} type="video/webm" />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Hero;
